// extracted by mini-css-extract-plugin
module.exports = {"tableItemList":"TableItemList_tableItemList__tHrjq","tableItem":"TableItemList_tableItem__33iEm"};